module.exports = __webpack_public_path__ + "static/kismet2.4920e277.png";